import { useQuery } from '@tanstack/react-query';

import { getWorkflow } from '@/services/workflow/get-workflow';
import { useOrgStore } from '@/stores/org-store';

export function useWorkflowDetail(
  workflowId?: string,
  { includeCost = false }: { includeCost?: boolean } = {},
) {
  const orgId = useOrgStore((state) => state.currentOrg?.orgid);
  const enabled = !!orgId && !!workflowId;

  return useQuery({
    queryKey: ['workflow-detail', orgId, workflowId, { includeCost }],
    queryFn: () => getWorkflow(workflowId!, orgId!, { includeCost }),
    enabled,
    staleTime: 30_000,
    retry: 1,
    // Opting into the cost changes the key mid-card, and without the last
    // answer to hold onto, a run reaching completion drops its own name for
    // as long as the refetch takes.
    placeholderData: (previous) => previous,
  });
}
